export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/Loading.56c0e9c6.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};